// Central de Atendimento — wrapper REST sobre /api/chat/ai (contrato do backend)
import { fetchAuth } from './apiClient';

const BASE = '/api/chat/ai';

const jsonHeaders = { 'Content-Type': 'application/json' };

async function post(path, body) {
  const { res, data } = await fetchAuth(path, {
    method: 'POST',
    headers: jsonHeaders,
    body: JSON.stringify(body || {}),
  });
  return { res, data };
}

async function patch(path, body) {
  const { res, data } = await fetchAuth(path, {
    method: 'PATCH',
    headers: jsonHeaders,
    body: JSON.stringify(body || {}),
  });
  return { res, data };
}

// ---- Sessões (conversas do chat com visitantes) ----
export function listSessions({ status, page = 1, limit = 30, q } = {}) {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  if (page) params.set('page', String(page));
  if (limit) params.set('limit', String(limit));
  if (q) params.set('q', q);
  const qs = params.toString();
  return fetchAuth(`${BASE}/sessions${qs ? `?${qs}` : ''}`);
}

export function getSessionMessages(sessionId, { page, limit } = {}) {
  const params = new URLSearchParams();
  if (page) params.set('page', String(page));
  if (limit) params.set('limit', String(limit));
  const qs = params.toString();
  return fetchAuth(`${BASE}/sessions/${sessionId}/messages${qs ? `?${qs}` : ''}`);
}

export function assumirSessao(sessionId, body) {
  return post(`${BASE}/sessions/${sessionId}/assumir`, body);
}

export function enviarMensagem(sessionId, content, extras) {
  return post(`${BASE}/sessions/${sessionId}/mensagem`, { content, ...(extras || {}) });
}

export function transferirSessao(sessionId, body) {
  return post(`${BASE}/sessions/${sessionId}/transferir`, body);
}

export function finalizarSessao(sessionId, motivo) {
  return post(`${BASE}/sessions/${sessionId}/finalizar`, motivo ? { motivo } : {});
}

export function reabrirSessao(sessionId) {
  return post(`${BASE}/sessions/${sessionId}/reabrir`, {});
}

export function devolverSessao(sessionId) {
  return post(`${BASE}/sessions/${sessionId}/devolver`, {});
}

export function criarTicketSessao(sessionId, body) {
  return post(`${BASE}/sessions/${sessionId}/ticket`, body);
}

// ---- Atendentes ----
export function listAtendentes() {
  return fetchAuth(`${BASE}/atendentes`);
}

export function setMyStatus(status) {
  return patch(`${BASE}/atendentes/me`, { status });
}

// ---- Estatísticas / contadores ----
export function getEstatisticas() {
  return fetchAuth(`${BASE}/estatisticas`);
}

// ---- Respostas rápidas ----
export function listRespostas() {
  return fetchAuth(`${BASE}/respostas`);
}

// ---- Config pública do chat (widget) ----
export function getConfigPublica() {
  return fetchAuth(`${BASE}/config/publica`);
}

// ---- Anexos ----
export async function enviarAnexoSessao(sessionId, file) {
  const form = new FormData();
  form.append('arquivo', file);
  return fetchAuth(`${BASE}/sessions/${sessionId}/anexo`, {
    method: 'POST',
    body: form,
  });
}

// Anexo do visitante (widget público) — POST /api/chat/anexo
export async function enviarAnexoChat({ file, sessionId, clientMsgId }) {
  const form = new FormData();
  form.append('arquivo', file);
  if (sessionId) form.append('sessionId', sessionId);
  if (clientMsgId) form.append('clientMsgId', clientMsgId);
  return fetchAuth('/api/chat/anexo', { method: 'POST', body: form });
}
